<template>
  <div :class="[{ 'p-14 text-center': centered }]">
    <SfLoaderCircular
      :class="[
        { '!text-neutral-300 !ring-primary-700': type === 'primary' },
        { '!text-secondary-200 !ring-secondary-700': type === 'secondary' },
      ]"
      :size="size"
    />
  </div>
</template>

<script setup lang="ts">
import type { LoaderProps } from '~/components/ui/Loader/types';

withDefaults(defineProps<LoaderProps>(), { size: '2xl', type: 'primary' });
</script>
